// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/folder.js';

import { paths } from '../generated/folder';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('folder', Original, paths);
